import React from 'react';
import {
  Button,
  type ButtonProps,
  CircularProgress,
  ThemeProvider,
} from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { getCustomLoadingButtonTheme } from './custom-loading-button.theme';

interface CustomLoadingButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: React.ReactNode;
  loadingComponent?: React.ReactNode;
  loadingSize?: number;
}

export const CustomLoadingButton = React.forwardRef<
  HTMLButtonElement,
  CustomLoadingButtonProps
>(
  (
    {
      loading = false,
      loadingText,
      loadingComponent,
      loadingSize = 20,
      children,
      ...props
    },
    ref
  ) => {
    const { enableDarkTheme } = useAppTheme();
    const theme = getCustomLoadingButtonTheme(
      enableDarkTheme ? 'dark' : 'light'
    );

    return (
      <ThemeProvider theme={theme}>
        <Button {...props} ref={ref} variant={props.variant ?? 'contained'}>
          {loading &&
            (loadingComponent ?? (
              <CircularProgress size={loadingSize} color="inherit" />
            ))}
          {!loading && children}
          {loading && loadingText && (
            <span style={{ marginLeft: 8 }}>{loadingText}</span>
          )}
        </Button>
      </ThemeProvider>
    );
  }
);

CustomLoadingButton.displayName = 'CustomLoadingButton';
